import React from "react";
import "./App.css";
import MatrixCanva from "./components/FrontPage/MatrixCanva";
import NavBar from "./components/NavBar/NavBar";
import FrontText from "./components/FrontText/FrontText";
import { Container, Row, Col } from "react-bootstrap";
import AboutMe from "./components/AboutMe/AboutMe";
import ExperienceMain from "./components/Experience/ExperienceMain";
import ScrollAnimation from "./components/ScrollAnimation/ScrollAnimation";
import Footer from "./components/Footer/Footer";
import { HighlightProvider } from "./components/ContextProviders/HighlightContext";
import GridProjects from "./components/Proyects/GridProjects";
import PortfolioGame from "./components/PortfolioGame";


function App({ canvaID }) {

  // window.addEventListener('load', function() {
  //   setTimeout(function() {
  //     window.scroll(window.screen.width/6, );
  //   },1)
  // })

  return (

    <div className="App">
      <section id="home" />
      <Container fluid className='py-3'>
        <Row>
          <Col className='fade-in-image'>
            <div className="matrix-canva" id="container" >
              <NavBar />
              <HighlightProvider>

                <Container className="image-and-text">

                  <FrontText></FrontText>

                </Container>
                <MatrixCanva /> {/*Rendering this component helps loading the canvas with the ID*/}
                <section id="about-me" />
                <ScrollAnimation component={<AboutMe />}>

                </ScrollAnimation>

              </HighlightProvider>
              <section id="experience" />
              <br></br>
              <ExperienceMain></ExperienceMain>
              <section id="projects" />

              <GridProjects></GridProjects>

            </div>
            <Footer></Footer>

          </Col>
        </Row>
      </Container>
      <PortfolioGame />

    </div>
  );
}

export default App;